<template>
    <div>
        <ul>
            <li v-for="(item, index) in infoList" :key="index">
                <div v-on:click="handlerAccordino" :data-index="index">
                    <a :title="item.title + ' 열기'">
                      <div>
                          <span class="ellipsis-1">{{ item.title }}</span>
                      </div>
                    </a>
                    <button :title="item.title + ' 열기'" class="icon-small-bottom-arrow"></button>
                </div>
                <div class="gray-text-wrap">
                    <div class="product-precautions">
                        <div>
                          <!-- <span class="icon-tool-tip"></span> -->
                          <strong>{{ item.subject }}</strong>
                        </div>
                        <ul>
                          <li v-for="(t, index2) in item.texts" :key="index2">
                              <p><span></span><em>{{ t.text }}</em></p>
                          </li>
                        </ul>
                        <div>
                            <strong v-if="item.subject2">{{ item.subject2 }}</strong>
                          </div>
                        <ul v-if="item.texts2">
                          <li v-for="(t, index2) in item.texts2" :key="index2">
                              <p><span></span><em>{{ t.text }}</em></p>
                          </li>
                        </ul>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ProductDetailBuyList',
    data() {
        return {
            infoList: [
                {
                    title: "상품안내",
                    subject: "이용 안내", 
                    texts: [
                        { text: "해당 상품은 유효기간이 별도로 존재 하지 않습니다." },                        
                        { text: "상품 결제 시 계산대에서 본 이마티콘을 제시해 주세요." },                        
                        { text: "이마트 매장에서 구매하려는 상품의 최종 금액이 이마티콘의 액면가보다 높을 경우, 추가 금액을 지불해야 합니다." },
                        { text: "본 이마티콘은 잔액관리형으로 잔액 범위 내에서 반복하여 사용 가능합니다." },
                        { text: "잔액 조회는 앱내 보관함을 통해 확인 가능합니다." },
                        { text: "이마티콘 사용시 기타 할인쿠폰과 중복 사용 및 신세계 포인트 적립 가능합니다." },
                        { text: "휴대전화번호 오입력으로 인한 발송 실패 및 오발송에 대한 책임은 고객에게 있습니다. 단, 이마티콘이 사용되기 전에 고객센터를 통해 오발송 정정 신청을 한다면 수신자를 정정하여 발송할 수 있습니다." },
                        { text: "구매한 이마티콘은 이마트앱의 이마티콘 보관함에서 이마티콘 및 구매내역을 확인하실 수 있습니다." },
                        { text: "선물시에 입력한 문자로 이마티콘이 발송 됩니다. (이마트앱 보관함에 자동으로 등록되지 않습니다.)" },
                    ],
                    subject2: "사용 가능 매장", 
                    texts2: [
                        { text: "이마트, 트레이더스, 에브리데이 및 전문점 (노브랜드 직영점 , 일렉트로마트 , 몰리스샵 등)에서 사용이 가능합니다. ※ 이마트 안양점, 부천점, 일부 에브리데이 가맹점, 노브랜드 가맹점 매장에서는 사용이 불가합니다." },
                        { text: "이마트에 입점되어 있는 임대매장(푸드코트) 및 문화센터 등에서는 사용이 불가합니다." },                        
                        { text: "이마트몰/SSG.COM, 이마트24 에서는 사용이 불가합니다." },
                    ],
                },
                {
                    title: "상품정보고시",
                    subject: "상품 정보", 
                    texts: [
                        { text: "발행자  : ㈜ 이마트" },                        
                        { text: "유효기간 :  별도 유효기간 없음" },                        
                        { text: "이용조건"},
                        { text: "이마트, 트레이더스, 에브리데이, 이마트 전문점에서 사용 가능합니다." },
                        { text: "해당 이마티콘은 별도 유효기간이 존재 하지 않습니다." },
                        { text: "이용약관에 따라 환불이 취소/환불이 가능합니다.​" },
                        { text: "지급보증" },
                        { text: "이마티콘은 구매 및 충전금액에 대하여 전자상거래(결제수단) 보증보험증권에 가입되어 있습니다." },
                    ],
                },
                {
                    title: "취소, 환불 및 유의사항",
                    subject: "환불 안내", 
                    texts: [
                        { text: "구매하거나 충전한 정상카드의 잔액은 현금으로 반환되지 않습니다, 단, 이마티콘 액면가 기준 60% 이상 사용시, 남은 잔액의 100% 대하여 환불 요청이 가능합니다. (단 , 할인 판매된 이마티콘의 경우 구매금액을 기존으로 사용 비율에 따라 계산하여 남은 비율 잔액의 100%에 대해 환불 요청 가능합니다.)" },                        
                        { text: "환불은 이마트 App 또는 고객센터(02-380-5030)를 통해 신청할수 있습니다." },
                        { text: "환불을 요청할수있는 권리는 이마티콘 최종 수신자에게 있으며, 수신자의 요청을 통해 환불 진행합니다, 이떄, 수신자 본인 확인 절차를 거칠수 있습니다." },                        
                        { text: "이마티콘으로 구매한 상품을 불량등의 사유로 환불할 경우 , 해당 이마티콘의 잔액이 복구됩니다​" },                        
                        { text: "충전한 이마티콘의 경우 최종 충전 후 합계 잔액의 60% 이상이 사용된 경우에만 가능합니다" },
                    ],
                    subject2: "구매 취소 조건 및 방법",
                    texts2: [
                      {"text": "구매자란 이마트앱에서 이마티콘을 구매한 고객을 말합니다​"},
                      {"text": "구매한 이마티콘을 미사용했을경우 , 구매자는 취소를 할수 있습니다 ​"},
                      {"text": "구매 취소는 이마트앱 >이마티콘> 카드보관함> 주문내역에서 신청할수 있습니다."},
                    ]
                },
            ],
            classname: "",
        }
    },
    mounted() {
    },
    methods: {
        handlerAccordino(e) {
            const currentTarget = e.currentTarget;
            const grayTextbox = document.querySelectorAll('.gray-text-wrap');
            console.log(grayTextbox);
            grayTextbox.forEach((item, index) => {
                Number(currentTarget.dataset.index) === index ? item.classList.toggle('on') : item.classList.remove('on');
                if(item.className.includes('on')) {
                  currentTarget.children[1].className = "icon-small-top-arrow";
                  currentTarget.children[0].title = currentTarget.textContent + " 닫기";
                  currentTarget.children[1].title = currentTarget.textContent + " 닫기";
                } else {
                  item.previousSibling.children[1].className = "icon-small-bottom-arrow";
                  item.previousSibling.children[0].title = item.previousSibling.textContent + " 열기";
                  item.previousSibling.children[1].title = item.previousSibling.textContent + " 열기";
                }
            })
        },
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/common/productDetailBuyList.scss';
</style>

